import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '550px',
    '& .Mui-error': {
      // color: 'white',
    },
    '& .MuiFormHelperText-root': {
      fontSize: '14px !important',
      color: '#f44336',
    },
  },
  withMargin: {
    marginBottom: '16px',
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '20px',
  },
  buttonsMargin: {
    marginLeft: '16px',
  },
  switch: {
    marginTop: '16px',
    marginLeft: '-11px',
    '& .MuiSwitch-root': {
      width: '68px',
    },
    '& .MuiSwitch-switchBase': {
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },
  },
  container: {
    display: 'flex',
  },
  customBorder: {
    '& .MuiFormHelperText-contained': {
      marginLeft: 0,
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      paddingTop: '14px',
      paddingBottom: '11px',
    },
    '& .MuiInputBase-input::placeholder': {
      fontSize: '14px',
      color: '#C2C2C2',
    },
    '& .MuiOutlinedInput-root': {
      height: '43.6px',
      '& fieldset': {
        borderColor: '#919191',
        borderWidth: '1px',
      },
      '&.Mui-disabled fieldset': {
        borderColor: theme.palette.grey[300],
      },
      borderRadius: '8px',
      '&:hover fieldset': {
        transition: 'all 0.5s ease',
        borderColor: '#3068f9',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3068f9',
        borderWidth: '1px',
        boxShadow: '0 0 0 0.15rem #edf2ff',
      },
    },
    '& .MuiAutocomplete-tag': {
      margin: 0,
      height: '24px',
      marginRight: '8px',
    },
  },
  inputLabel: {
    marginBottom: '4px',
    fontSize: '13.6px',
    color: '#919191',
  },
  flex: {
    display: 'flex',
  },
  fullFlexWidth: {
    flex: 1,
  },
  withRightMargin: {
    marginRight: '16px',
  },
  inputFont: {
    color: '#304968',
    '& .MuiInputBase-input::placeholder': {
      color: '#C2C2C2',
      opacity: 1,
    },
  },
  selectPlaceholder: {
    fontSize: '14px',
    color: '#C2C2C2',
  },
  inputRoot: {
    paddingRight: '24px !important',
    borderRadius: '8px',
    height: '44px',
    '& .MuiInputBase-input': {
      paddingTop: '0 !important',
      paddingBottom: '0 !important',
    },
  },
  selectHeight: {
    height: '44px',
    '& .MuiSelect-icon': {
      top: '14px',
    },
  },
  switchBase: {
    padding: '12px',
    '&$checked': {
      color: '#3068F9',
      '& .MuiIconButton-label': {
        width: '25px',
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: '#3068F9',
      },
    },
    '&$checked + $track': {
      backgroundColor: '#EDF2FF',
    },
    '& .MuiIconButton-label': {
      width: '20px',
      height: '20px',
    },
    '& .MuiSwitch-thumb': {
      width: '16px',
      height: '16px',
    },
  },
  checked: {},
  track: {
    backgroundColor: `${theme.palette.grey[300]} !important`,
    height: '20px !important',
    borderRadius: '30px !important',
  },
  switchLabel: {
    fontSize: '12px',
    paddingTop: '6px',
  },
  primaryButton: {
    backgroundColor: '#3068F9',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: '#0539be',
      boxShadow: 'none',
    },
    padding: '12px 24px',
    transition: 'all .5s ease',
    boxShadow: 'none',
  },
  secondaryButton: {
    border: '1px solid #3068F9',
    borderRadius: '8px',
    '& .MuiButton-label': {
      color: '#3068F9',
    },
    '&:hover': {
      backgroundColor: '#ffffff',
      border: '1px solid #0539be',
      '& .MuiButton-label': {
        color: '#0539be !important',
      },
    },
    padding: '12px 24px',
  },
  errorLabel: {
    marginLeft: 0,
  },
  customTimePicker: {
    '& fieldset': {
      borderColor: '#919191',
    },
    '& .MuiFormLabel-root': {
      fontSize: '14px !important',
      paddingTop: '4px',
      opacity: 0.5,
    },
  },
  scheduleWrapper: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid',
    paddingBottom: '10px',
    marginBottom: '10px',
  },
  infoBelowAutocomplete: {
    textAlign: 'left',
    padding: '10px 0 30px 0',
    color: 'green',
    fontSize: '20px',
  },
  addCompanionButton: {
    marginTop: '24px',
  },
  flexColumnCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  topMargin: {
    marginTop: '16px',
  },
  iconButton: {
    marginTop: '4px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  centerText: {
    '& .MuiOutlinedInput-input': {
      paddingTop: '24px',
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiOutlinedInput-root': {
      paddingTop: '12px',
    },
  },
  marginTop: {
    marginTop: '26px',
  },
  chipContainer: {
    marginBottom: '24px',
  },
  chip: {
    marginRight: '8px',
    marginBottom: '8px',
  },
  paper: {
    backgroundColor: '#ffffff',
    width: '100%',
    padding: '64px 0 32px 84px',
    paddingLeft: '84px',
    overflowY: 'scroll',
  },
  checkbox: {
    '& .MuiSvgIcon-root': {
      fill: '#304968',
    },
    '&:hover .MuiSvgIcon-root': {
      fill: '#3068f9',
    },
    '&.Mui-checked .MuiSvgIcon-root': {
      fill: '#3068f9',
    },
  },
  selectOption: {
    padding: '8px 16px',
    color: '#ffffff',
    // The global span colour would otherwise win over a custom renderOption.
    '& span': {
      color: 'inherit',
    },
    '&:hover': {
      backgroundColor: '#007aff',
      color: '#ffffff',
    },
    '&[aria-selected="true"]': {
      backgroundColor: '#007aff',
      color: '#ffffff',
    },
    '&.Mui-selected': {
      backgroundColor: '#007aff',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: '#007aff',
      },
    },
  },
  selectPaper: {
    backgroundColor: '#4a4a4a',
  },
  extraWidth: {
    width: '800px',
  },
  photoContainer: {
    '& > * > video': {
      width: '100%',
    },
  },
  selfie: {
    width: '100%',
  },
  inputTransform: {
    '&::placeholder': {
      textTransform: 'none',
    },
    textTransform: 'capitalize',
  },
  formError: {
    color: '#f44336',
    marginTop: '4px',
    fontSize: '14px !important',
  },
  mobile: {
    width: 'auto',
    minWidth: 0,
  },
}))

export default useStyles
